import { render, staticRenderFns } from "./AnimalAvatar.vue?vue&type=template&id=08833656&scoped=true&"
import script from "./AnimalAvatar.vue?vue&type=script&lang=js&"
export * from "./AnimalAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08833656",
  null
  
)

export default component.exports